import { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
  DecorativeLine,
  Button,
  Span,
  Form,
  Title,
  InputLogin,
  CheckBox
} from 'components'
import { useAuth, useEnvironment, useModal, useToggle } from 'hooks'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { UserServices } from 'services/Supplier/Users'
import { COLORS, SPACING } from 'utils'
import * as yup from 'yup'

import useLoading from '../../../../hooks/useLoading'
import { Header } from '../../components/Header/Header'
import {
  ChangePasswordModal,
  PasswordProps
} from '../ChangePasswordModal/ChangePasswordModal'
import { PasswordRecoveryModal } from '../PasswordRecoveryModal/PasswordRecoveryModal'
import { Container, TitleContainer } from './FornecedorAccessstyles'
import FullScreenLoading from '../ValidatingAccess'

export interface InputValues {
  email?: string
  password?: string
  rememberMe?: boolean
}

const schema = yup.object({
  email: yup
    .string()
    //.email('Digite um email válido')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
    .required('Campo obrigatório'),
  password: yup.string().required('Campo obrigatório')
})

export const FornecedoAccess = () => {
  const [isChangePassword, toggleChangePassword] = useToggle()
  const [isPasswordRecovery, togglePasswordRecovery] = useToggle()
  const [loadingCSN, setLoadingCSN] = useToggle(true);
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm<InputValues>({
    defaultValues: { email: '', password: '', rememberMe: false },
    resolver: yupResolver(schema)
  })
  const { handleLogin, user } = useAuth()
  const { setLoading } = useLoading()
  const { showModal } = useModal()

  const [isHide, setIsHide] = useState<boolean>(false)
  const { website_url } = useEnvironment()
  const handleChangePassword = async (data: PasswordProps) => {
    setLoading('loading')
    try {
      const response = await UserServices().changePassword({
        email: user.TxEmail,
        newPassword: data.newPassword
      })
      if (response.status !== 200 || !response.data.sucesso)
        throw new Error(response.data.mensagem || 'Erro ao alterar senha.')

      toggleChangePassword()
      showModal({
        hideButtonCancel: true,
        message: 'Salvo com sucesso!',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })

      setLoading('idle')
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: error?.mensagem || error?.message || 'Erro ao alterar senha.',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }

  const handleRequestNewPassword = async (data: any) => {
    setLoading('loading')

    UserServices()
      .requestNewPassword({
        email: data.email,
        url: website_url
      })
      .then((response) => {
        if (response.status !== 200 || !response.data.sucesso) {
          throw new Error(response.data.mensagem)
        }

        togglePasswordRecovery()
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'E-mail de recuperação de senha, enviado com sucesso!',
          titleModal: 'Recuperação de Senha!',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      })
      .catch((error: any) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error?.response?.data?.mensagem ||
            error?.message ||
            error?.messagem ||
            'Erro ao alterar senha.',
          titleModal: 'Recuperação de Senha',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleSubmitLoginFornecedor = (data: InputValues) => {
    handleLogin({
      email: data.email,
      isCsn: false,
      password: data.password,
      rememberMe: data.rememberMe
    })
  }

  const handleValidatingAccess = () => {
    UserServices()
      .getSSOCredentials()
      .then((response) => {
        if (response.status === 200) {
          const { data: matricula } = response
          try {
            handleLogin(
              {
                email: matricula?.toUpperCase(),
                isCsn: true,
                password: '',
                rememberMe: true
              }, setLoadingCSN
            )
          } catch (error) {
            setLoadingCSN(false)
          }
        }
      })
      .catch(() => {
        setLoadingCSN(false)
      })
  }

  useEffect(() => {
    const isLogout = localStorage.getItem('logout');

    if (!isLogout)
      handleValidatingAccess()
    else
      setLoadingCSN(false)
  }, [])

  return (
    <>
      {
        loadingCSN ? (
          <>
            <FullScreenLoading title="VERIFICANDO CREDENCIAIS" />
          </>
        ) : (
          <>
            <Header />
            <Container>
              <TitleContainer>
                <Title fontcolor={COLORS.black} marginbottom="15px" margintop="15px">
                  Faça login na sua conta
                </Title>
              </TitleContainer>
              <DecorativeLine colorLine={COLORS.black} height="4px" />
              <Form
                onSubmit={handleSubmit(handleSubmitLoginFornecedor)}
                marginLeft={SPACING.spacing50}
                marginRight={SPACING.spacing50}
              >
                <>
                  <>
                    <InputLogin
                      label="E-mail"
                      formValue="email"
                      control={control}
                      errors={errors}
                      marginTop={SPACING.spacing20}
                    />
                    <InputLogin
                      label="Senha"
                      formValue="password"
                      control={control}
                      errors={errors}
                      type={isHide ? 'text' : 'password'}
                      inputIcon={isHide ? <VisibilityOff /> : <Visibility />}
                      onClickIcon={() => setIsHide(!isHide)}
                      marginBottom={SPACING.spacing15}
                      marginTop={SPACING.spacing20}
                    />
                  </>

                  <Controller
                    name="rememberMe"
                    control={control}
                    defaultValue={false}
                    render={({ field }) => (
                      <CheckBox
                        label="Lembrar de mim?"
                        onClick={field.onChange}
                        checked={field.value}
                      />
                    )}
                  />
                </>

                <Span
                  text="Esqueceu a senha?"
                  textAlign="end"
                  marginTop={SPACING.spacing15}
                  marginBottom={SPACING.spacing15}
                  color={COLORS.black}
                  cursor="pointer"
                  onClick={togglePasswordRecovery}
                />
                <Button
                  text="entrar"
                  type="submit"
                  variantButton="default"
                  marginBottom={SPACING.spacing20}
                  marginTop={SPACING.spacing15}
                />
              </Form>
            </Container>
            {!!isChangePassword && (
              <ChangePasswordModal
                open={isChangePassword}
                handleClose={toggleChangePassword}
                handleChangePassword={handleChangePassword}
              />
            )}
            {!!isPasswordRecovery && (
              <PasswordRecoveryModal
                open={isPasswordRecovery}
                handleClose={togglePasswordRecovery}
                onSubmit={handleRequestNewPassword}
              />
            )}
          </>)
      }</>)

}
